import moment from 'moment';
import { germanDateFormat } from '@/utilities/germanFormats';

import { authService } from '@/services/authService';
import type { ApplicationDebugDto } from '@/types/forms/specific/applicationForm';

export const debugDto: ApplicationDebugDto = {
    location: {
        zipAndCity: {
            zip: '12345',
            city: 'TestCity1',
        },
        streetAndHousenumber: {
            street: 'StreetCity1',
            housenumber: '1',
        },
        availabilityResult: 'available',
        geographicLatCoordinates: {
            degrees: '53',
            minutes: '8',
            seconds: '16',
        },
        geographicLngCoordinates: {
            degrees: '8',
            minutes: '12',
            seconds: '17,2',
        },
    },
    controllableConsumptionDevices: {
        gridControlConditionsAccepted: true,
    },
    powerConnection: {
        doesConnectionExist: 'yes',
        whichVoltageLevel: 'lowVoltage',
    },
    plantOperator: {
        separatePropertyOwner: 'yes',
        plantBuilder: 'operator',
        operators: [
            {
                salutation: 'mr',
                title: 'untitled',
                operatorName: { firstName: 'Tester', lastName: 'Test' },
                birthday: '01.01.2021',
            },
        ],
        country: 'deu',
        zipAndCity: { zip: '26121', city: 'Oldenburg' },
        streetAndHousenumber: { street: 'Adolf-Grimme-Str.', housenumber: '1' },
        email: authService.email ?? '',
        emailRepeat: authService.email ?? '',
        phoneNumber1: '12345',
    },
    plantBuilder: {
        installerNotListed: true,
        companyName: 'Test Company',
        builderName: { firstName: 'Tester', lastName: 'Test' },
        country: 'deu',
        zipAndCity: { zip: '26121', city: 'Oldenburg' },
        streetAndHousenumber: { street: 'Adolf-Grimme-Str.', housenumber: '1' },
        email: authService.email ?? '',
        phoneNumber1: '12345',
    },
    propertyOwner: {
        owners: [
            {
                salutation: 'mr',
                title: 'untitled',
                ownerName: { firstName: 'Tester', lastName: 'Test' },
                birthday: '01.01.2021',
                country: 'deu',
                zipAndCity: { zip: '26121', city: 'Oldenburg' },
                streetAndHousenumber: {
                    street: 'Adolf-Grimme-Str.',
                    housenumber: '1',
                },
                email: authService.email ?? '',
                phoneNumber1: '12345',
            },
        ],
        propertyOwnerAgreement: true,
    },
    plantData: {
        newOrExistingApplication: 'new',
        newOrExistingPlant: 'first',
        storageConnectionConcept:
            'storageWithoutPowerGenerationPlantAndWithoutConsumptionPlant',
        storageCharge: 'onlyFromEeg',
        storageDischarge: 'onlyIntoCustomersGridSelfSupply',
        storageCoupling: 'acCoupled',
    },
    plantPerformance: {
        photovoltaic: {
            pvModules: [
                {
                    pvQuantityAndNominalPower: {
                        quantity: 1,
                        nominalPower: '200',
                    },
                    pvTotalNominalPower: 200,
                },
            ],
            pvOverallNominalPower: 0.2,
        },
        inverter: {
            inverterModules: [
                {
                    inverterManualInputManufacturerTypeZerezId: true,
                    inverterManufacturerAndModuleType: {
                        manufacturer: 'Muster',
                        manufacturerText: 'Muster',
                        moduleType: 'Muster Boy 0,8',
                        moduleTypeText: 'Muster Boy 0,8',
                    },
                    inverterQuantity: 1,
                    inverterActivePowerAndApparentPower: {
                        activePower: '0,8',
                        apparentPower: '0,8',
                    },
                    inverterTotalActivePower: 0.8,
                    inverterTotalApparentPower: 0.8,
                },
            ],
            inverterOverallActivePower: 0.8,
            inverterOverallApparentPower: 0.8,
        },
        storage: {
            storageModules: [
                {
                    storageManufacturerAndStorageType: {
                        manufacturer: 'EW Speicher 2',
                        storageType: 'S4 E Pro',
                    },
                    storageQuantity: 2,
                    storageDischargePowerAndStorageCapacity: {
                        dischargePower: '12',
                        storageCapacity: '12',
                    },
                    storageTotalDischargePower: 24,
                    storageTotalStorageCapacity: 24,
                },
            ],
            storageOverallDischargePower: 24,
            storageOverallStorageCapacity: 24,
        },
        generator: {
            generatorModules: [
                {
                    generatorManualInputManufacturerTypeZerezId: true,
                    generatorManufacturerAndModuleType: {
                        manufacturer: 'Muster',
                        manufacturerText: 'Muster',
                        moduleType: 'Muster Wind 0,8',
                        moduleTypeText: 'Muster Wind 0,8',
                    },
                    generatorQuantityAndGeneratorType: {
                        quantity: 1,
                        generatorType: 'type1',
                    },
                    generatorActivePowerAndApparentPower: {
                        activePower: '0,7',
                        apparentPower: '0,8',
                    },
                    generatorTotalActivePower: 0.7,
                    generatorTotalApparentPower: 0.8,
                },
            ],
            generatorOverallActivePower: 0.7,
            generatorOverallApparentPower: 0.8,
        },
        certificateHint: true,
    },
    measuringConcepts: {
        operatingMode: 'fullInfeed',
        meterNumber: '123456789',
        selfGenerationQuantity: '170,00',
        selfSupplyQuantity: '170,00',
    },
    documents: {
        sitePlanWithLotNumber: null,
    },
    billing: {
        iban: 'DE89370400440532013000',
        date: moment().add(1, 'day').format(germanDateFormat),
        accountOwnerName: 'Tester Test',
        noFinancialDistress: true,
        noPendingEURecoveryClaims: true,
    },
    checkAndSend: {
        privacyInformation: true,
        generalTermsConsent: true,
    },
};
